import { AbortControllerManager } from '../abortControllerManager';
import { authClient } from '../client';
import { IGetVitalTracTokenResponse } from '@/types/vitaltrac';

class VitalTracApi extends AbortControllerManager {
  private VITAL_TRAC_URL = '/v2/vitaltrac';

  constructor() {
    super();
  }

  getToken(): Promise<IGetVitalTracTokenResponse> {
    const url = `${this.VITAL_TRAC_URL}/token`;
    const signal = this.createAbortController('getToken');
    return authClient.get(url, { signal });
  }
}

export const vitalTracApi = new VitalTracApi();
